<template>
    <form-element
        v-bind="$props"
        v-on="$listeners"
    >
        <search-contact
            v-model="searchedContact"
            :on-create="onCreate"
            :on-edit="onEdit"
        />
    </form-element>
</template>

<script>
import mixin from '@spa/components/_Form/mixin';
import { searchContactFormMixinProps } from "./mixin";
import FormElement from '@spa/components/_Form/Element.vue';
import SearchContact from './Search.vue';

export default {
    mixins: [{
        ...mixin,
        props: {
            ...mixin.props,
            label: {
                ...mixin.props.label,
                default() {
                    return this.$t('form.labels.contacts.name');
                }
            }
        }
    }],
    components: {
        FormElement,
        SearchContact
    },
    props: {
        ...searchContactFormMixinProps,
        /** Automatically triggered when contact is updated. */
        onContactUpdated: {
            type: Function,
            default: (contact) => {}
        },
        onInit: {
            type: Function,
            required: false,
            default: () => {}
        }
    },
    data() {
        return { contact: null }
    },
    methods: {
        setContact(contact) {
            this.searchedContact = contact;
            return this;
        }
    },
    computed: {
        searchedContact: {
            get() { 
                return this.contact;
            },
            /** @param {?import("@deegital/trustup-spa-js-assets/types/api/app/contact").ContactInterface} contact */
            set(contact) {
                this.contact = contact ?? null;
                this.model = contact?.uuid ?? null;
                this.onContactUpdated(this.contact);
            }
        }
    },
    created() {
        this.onInit({ setContact: this.setContact });
    }
}
</script>